import PageLeaderboard from './PageLeaderboardContainer';

export default PageLeaderboard;
